import { useEffect, useState } from 'react'
import { Clock, MapPin } from 'lucide-react'
import WhatsAppIcon from '@/components/icons/WhatsAppIcon'
import { CULTES } from '@/data/cultes'
import { useLiens } from '@/hooks/useContent'
import { getDateForJour, getProchainCulte } from '@/helpers/date'

export default function QuickInfoBar() {
  const [now, setNow] = useState(new Date())
  const liens = useLiens()

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 60_000)
    return () => clearInterval(interval)
  }, [])

  const prochainCulte = getProchainCulte(CULTES, now)

  return (
    <div className="relative z-20 -mt-8 md:-mt-10 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl shadow-cmp-navy/15 ring-1 ring-cmp-navy/5 grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-gray-100 overflow-hidden">
        <a
          href="#horaires"
          className="flex items-center gap-3 p-5 hover:bg-cmp-sky-light/50 transition-colors"
        >
          <div className="w-10 h-10 rounded-full bg-cmp-sky-light flex items-center justify-center shrink-0">
            <Clock size={18} className="text-cmp-blue" />
          </div>
          <div className="min-w-0 text-left">
            <p className="text-xs text-gray-400">Prochain culte</p>
            {prochainCulte ? (
              <>
                <p className="text-sm font-bold text-cmp-navy truncate">
                  {prochainCulte.jour} {getDateForJour(prochainCulte.jour).toLocaleDateString('fr-FR', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                  })}
                </p>
                <p className="text-sm font-bold text-cmp-navy truncate">
                  {prochainCulte.creneau.heureDebut} - {prochainCulte.creneau.heureFin}
                </p>
              </>
            ) : (
              <p className="text-sm font-bold text-cmp-navy truncate">Voir les horaires</p>
            )}
          </div>
        </a>

        <a
          href={liens.maps}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 p-5 hover:bg-cmp-sky-light/50 transition-colors"
        >
          <div className="w-10 h-10 rounded-full bg-cmp-sky-light flex items-center justify-center shrink-0">
            <MapPin size={18} className="text-cmp-blue" />
          </div>
          <div className="min-w-0 text-left">
            <p className="text-xs text-gray-400">Nous trouver</p>
            <p className="text-sm font-bold text-cmp-navy truncate">Ouvrir l'itinéraire</p>
          </div>
        </a>

        <a
          href={liens.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 p-5 hover:bg-cmp-sky-light/50 transition-colors"
        >
          <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center shrink-0">
            <WhatsAppIcon size={18} />
          </div>
          <div className="min-w-0 text-left">
            <p className="text-xs text-gray-400">Une question ?</p>
            <p className="text-sm font-bold text-cmp-navy truncate">Nous écrire</p>
          </div>
        </a>
      </div>
    </div>
  )
}
